
import { createSlice } from "@reduxjs/toolkit";


const jobSlice = createSlice({
    name: 'jobpost',
    initialState: {
        loading: false,
    },
    reducers: {
        jobPostCreateLoading(state, action) {
            return {
                loading: true,
            }
        },
        jobPostCreateSuccess(state, action) {
            return {
                loading: false,
                JobPosts: action.payload.JobPosts,
            }
        },
        jobPostCreateFail(state, action) {
            return {
                loading: false,
                error: action.payload
            }
        },
        jobPostAllLoading(state, action) {
            return {
                loading: true,
            }
        },
        jobPostAllSuccess(state, action) {
            return {
                loading: false,
                allJobPost: action.payload.allJobPost,
            }
        },
        jobPostAllFail(state, action) {
            return {
                loading: false,
                error: action.payload
            }
        },
        jobPostGetSingleLoading(state, action) {
            return {
                loading: true,
            }
        },
        jobPostGetSingleSuccess(state, action) {
            return {
                loading: false,
                singlejobpost: action.payload.singlejobpost,
            }
        },
        jobPostGetSingleFail(state, action) {
            return {
                loading: false,
                error: action.payload
            }
        },
        jobPostDeleteLoading(state, action) {
            return {
                loading: true,
            }
        },
        jobPostDeleteSuccess(state, action) {
            return {
                loading: false,
                deletejob: action.payload,
            }
        },
        jobPostDeleteFail(state, action) {
            return {
                loading: false,
                error: action.payload
            }
        },
    }
})

const { actions, reducer } = jobSlice;

export const {
    jobPostCreateLoading, jobPostCreateFail, jobPostCreateSuccess,
    jobPostAllLoading, jobPostAllSuccess, jobPostAllFail,
    jobPostGetSingleLoading, jobPostGetSingleSuccess, jobPostGetSingleFail,
    jobPostDeleteLoading, jobPostDeleteSuccess, jobPostDeleteFail
} = actions;


export default reducer;
